export const DeprecationWarnings = {
  ClearMarkings: buildMarkingsWarning(
    'clearMarkings',
    'api.markings.removeAll/removeAllWhere/removeMany/removeOne',
  ),
  Mark: buildMarkingsWarning('mark', 'api.markings.addOne/addMany'),
  ToggleMarking: buildMarkingsWarning('toggleMarking', 'api.markings.toggleOne/toggleMany'),
  Unmark: buildMarkingsWarning('unmark', 'api.markings.removeOne/removeMany'),
};

/**
 * Build warnings for the markings methods.
 */
function buildMarkingsWarning(deprecated: string, useInstead: string) {
  return `The "${deprecated}" method is deprecated and will be removed in v2.0.0. Please use the ${useInstead} methods instead.`;
}
